import { useEffect, useRef } from "react";
import EventBus, { EventBus as EventBusClass } from "@/utils/EventBus";


interface RegistryEntry { eventBus: EventBusClass, refsCount: number }
const eventBusRegistry : Map<string, RegistryEntry> = new Map()

export const useEventBus = (instanceName?: string) => {
  instanceName = instanceName ?? 'default'
  const entry =
    eventBusRegistry.has(instanceName)
    ? eventBusRegistry.get(instanceName)!
    : {
      eventBus: instanceName === 'default' ? EventBus : new EventBusClass(),
      refsCount: 0,
    }
  if (!eventBusRegistry.has(instanceName)) {
    eventBusRegistry.set(instanceName, entry)
  }
  const bagRef = useRef({
    eventBus: entry.eventBus,
    tokens: new Set<string>(),
    proxy: new Proxy<EventBusClass>(entry.eventBus, {
      get: (tgt, p) => {
        if (p !== 'subscribe' && p !== 'subscribeAll') {
          return tgt[p as keyof EventBusClass]
        }
        return (...params: any[]) => {
          const token = 
            p === 'subscribe'
            // @ts-expect-error expected
            ? tgt.subscribe(...params)
            // @ts-expect-error expected
            : tgt.subscribeAll(...params)
          bagRef.current.tokens.add(token)
          return token
        }
      },
    })
  })
  useEffect(() => {
    return () => {
      const { tokens, eventBus } = bagRef.current
      for (const token of tokens) {
        eventBus.unsubscribe(token)
      }
    }
  }, [])
  return bagRef.current.proxy
}
